// Modularity
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Component
import Login from "./Login";
import ChangePassword from "./ChangePassword";
import ForgetPassword from "./ForgetPassword";

// Images
import mainImg from "../../assets/images/Group171483.svg";

// Styles
import { Conatiner } from "./Auth.style";
import { useAppSelector } from "../../core/hooks/hooks";
import { getLoader } from "../../core/store/slices/loaderSlice";
import Spinner from "../../components/Spinner/Spinner";

const MainAuthForm = () => {
  const location = useLocation();
  const { pathname } = location;
	const loader = useAppSelector(getLoader);

  return (
    <Conatiner>
      <div className="authform">
        {pathname === "/forget-password" ? (
          <ForgetPassword />
        ) : pathname === "/reset-password" ? (
          <ChangePassword />
        ) : (
          <Login />
        )}
      </div>
      <div className="loginImg">
        <img className="mainImg" src={mainImg} alt="" />
      </div>
      {loader.show && <Spinner />}
    </Conatiner>
  );
};

export default MainAuthForm;
